import { buildTeamNameIndexKey } from "../buildTeamNameIndexKey";
export function tryFindTeamLogo(options) {
    if (shouldNotSearchForLogo(options)) {
        return;
    }
    const teamName = findTeamName(options.teamNames, options.filter.eventId, options.filter.venueRole);
    if (!teamName) {
        return;
    }
    const logo = options.teamsLogos.Teams[teamName];
    return logo && `${options.staticS3Host}${logo}`;
}
function findTeamName(teamNames, eventId, venueRole) {
    return eventId && teamNames.get(buildTeamNameIndexKey(eventId, venueRole));
}
function shouldNotSearchForLogo(options) {
    return !options.filter.eventId
        || !options.teamsLogos.Teams
        || options.filter.venueRole !== "Home"
            && options.filter.venueRole !== "Away";
}
//# sourceMappingURL=tryFindTeamLogo.js.map